<template>
  <div class='col-12 col-lg-6 g c'>
    <br><br><br><br><br><br>
    <div class="card card-body" style="border-radius: 50px">
        <h3 class="text-center">
            <a class="btn btn-lg btn-primary" target="_blank" href="https://app.octowhats.com/widget/688e9cf21eaf61ffd8759653?automessage=%D8%A7%D8%B1%D9%8A%D8%AF%20%D8%A7%D9%84%D8%A7%D8%B3%D8%AA%D9%81%D8%B3%D8%A7%D8%B1%20%D8%B9%D9%86%20%D9%86%D9%82%D8%A7%D8%B1%20%D8%A7%D9%84%D9%85%D8%B3%D8%A7%D8%B9%D8%AF%20%D8%A7%D9%84%D8%B0%D9%83%D9%8A">
              <i class="fa fa-comments"></i>
              المحادثة المباشرة (الرد الآلي)
            </a><br><br>
            -- أو --<br><br>
            تواصل عبر الواتساب على:
            <br><br>
            966580200670
            <br>
        </h3>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>